import React from 'react';
import './Contact.scss';
import { useNavigate } from "react-router-dom";

const Contact = () => {
    const navigate = useNavigate();

    return <div className='container contact fade-in-block'>        
        <div className='row'>
            <div className='col-12'>
                <h3>Contact</h3>
                <p>If you are considering attending psychotherapy sessions with me, please click the button below and complete the online form to get in touch.</p>                    
                <div className='button' onClick={() => navigate('/questionnaire')}>Open enquiry form</div> 
            </div>                
        </div>        
    </div>
}

export { Contact }